import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {UserContext, useUserContext} from "../contexts/user-context";
import {useEffect} from 'react';
import {useCallback} from 'react';
import {ModalWindow} from "./ModalWindow";
import {Button, IconButton, Tooltip} from "@mui/material";
import {AddBox, Delete,  Refresh, Save, Search} from "@mui/icons-material";
import {Select} from "./MaterialSelects/Select";
import {hookReturn} from "../utils";
import { FieldTableRendererCallback } from './FieldTable/FieldTableTypes';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import SplitButton from './searchHistoryDropdown';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';


function mapFieldToOption(field: any) {
    if (field.type === 'group') {
        //return {label: field.label, options: field.fields.map(mapFieldToOption)};
        return false;
    }
    return field;
}

/* a subtype of search field e.g. LIKE or LOOKUP */
type SearchFieldVariant = {
    default?: boolean,
    label: string,
    id: string,
    multi: boolean,
    editor: FieldTableRendererCallback<any,any>
}

/* used to represent the field in the query string */
type SearchFieldParam = {
    name: string,
    type: string,
    value?: string
}

type SearchFieldType = {
    label: string,
    id: string,
    default?: boolean,
    variants: SearchFieldVariant[]
}

type SearchFieldValue = {
    column: SearchFieldType,
    variant: SearchFieldVariant,
    value: any,
    searchName?: any
}

interface SearchFormRendererProps {
    handleSubmit: (fields:any)=>void,
    label: string,
    initialValues: SearchFieldValue[],
    fieldTypes: SearchFieldType[],
    isOpen: boolean,
    setValues: (newValues: SearchFieldValue[]) => void,
    values: SearchFieldValue[],
    setSelectedId: (id:string)=>void,
    loadFields: (doReturn: boolean) => SearchFieldValue[]|undefined,
    saveFields: (fields: SearchFieldValue[], searchName: any) => void,
    searchNameFormProp?: any[],
    setSearchName: (name:string)=>void,
    searchName:any,
    openSnackbar: boolean,
    toastMessage: string, 
    setOpenSnackbar: (value: boolean) => void, 
    setToastMessage: (message: string) => void, 
    propName:string
    onClose: () => void,
    setResponseOption?:string
}
const customCheckbox = {
  marginLeft: '10px'
};
const SearchFormRenderer = ({
  handleSubmit,
  label,
  initialValues,
  fieldTypes,
  isOpen,
  loadFields,
  saveFields,
  onClose,
  searchNameFormProp,
  setSelectedId,
  setValues,
  values,
  setSearchName,
  searchName,
  openSnackbar,
  toastMessage, 
  setOpenSnackbar,
  setToastMessage,
  propName, 
  setResponseOption
}: SearchFormRendererProps) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  /*const doLoadFields = () => {
    const fields = loadFields(true);
    console.log("[SFR]", "loaded", fields);
    if (fields) {
      setValues(fields);
    }
  }; - not used anywhere */
  const doResetFields = () => {
    setValues([]);
  }
  const doSaveFields = () => {
    if (searchName == '') {    
      setError(true);
    } else {
      saveFields(values, searchName);
      handleClose();
    }
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  console.log("[SFR] rendering with", initialValues, values);

  useEffect(() => {
    console.log("[SFR] rendering length change",[...values]);
    if (!values.length) {
      addRow();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.length]);
  const addRow = () => {
    let defaultType: SearchFieldType | null = null;
    console.log("[SFR] addRow");
    fieldTypes.forEach((ft) => {
      if (!defaultType) {
        defaultType = ft;
      }
    });
    console.log("[SFR] addRow - defaultType", defaultType);
    if (!defaultType) return;
    let defaultVariant:SearchFieldVariant|null = null;
    (defaultType as SearchFieldType).variants.forEach((variant) => {
      if (variant.default || !defaultVariant) {
        defaultVariant = variant;
      }
    });
    if (!defaultVariant) return;
    values.push({
      column: defaultType,
      variant: defaultVariant,
      value: (defaultVariant as SearchFieldVariant).multi ? [] : "",
    });
    console.log('[SFR] addRow - pushed',values);
    setValues([...values]);
  };
  const removeRow = (idx: number) => (evt) => {
    evt.preventDefault();
    values.splice(idx, 1);
    setValues([...values]);
  };
  const onChangeField = (evt) => {
    console.log("STS", "search onchange");
    const tgt = evt.target.name.split(".");
    const idx = parseInt(tgt[0]);
    const fieldName = tgt[1];
    const value = evt.target.value;
    console.log("set", idx, fieldName, value, evt.target);
    const field = values[idx];
    if (fieldName === "value") {
      if (field.variant.multi) {
        field.value = value;
      } else {
        field.value = value;
      }
    }
    else if(fieldName === "searchName"){
        const sn = evt.target.value;
        setSearchName(sn);
        setError(false); // Clear the error when the user starts typing
        console.log("SN" , sn);
    }
    else {
      if (fieldName === "column") {
        field.column = evt.target.value;
        field.variant = evt.target.value.variants[0];
      }
      if (fieldName === "variant") {
        field.variant = evt.target.value;
      }
      field.value = field.variant.multi ? [] : "";
    }
    values[idx] = field;
    console.log("values are", values);
    setValues([...values]);
  };
//  const title = label ? "Search " + label : "Search";
  const options = fieldTypes.map(mapFieldToOption);
  const renderFields = () => {
    const fieldContent = values.map(({ variant, column, value }, idx) => {
      const variantComponent =
        !variant || !variant?.id ? (
          <div className="empty" />
        ) : (
          variant.editor({
            name: idx + ".value",
            input: {
              flat: true,
              value: value,
              fill: true,
              name: idx + ".value",
              onChange: onChangeField,
              className: "search-value grid12-5",
              valueIsId: true
            },
          })
        );
      return (
        <div key={idx} style={{ display: "contents" }}>
          <Select
            className="grid12-clear grid12-3"
            label="Field"
            name={idx + ".column"}
            options={options}
            value={column}
            labelField="label"
            onChange={onChangeField}
          />
          <Select
            name={idx + ".variant"}
            options={column.variants}
            value={variant}
            labelField="label"
            label={"Match"}
            className="grid12-3"
            onChange={onChangeField}
          />
          {variantComponent}
          {/*<FormGroup className="narrow" label="&nbsp;">*/}
          {values.length > 1 && (
            <div className="grid12-1">
              <IconButton onClick={removeRow(idx)}>
                <Delete />
              </IconButton>
            </div>
          )}
          {/*</FormGroup>*/}
        </div>
      );
    });
    console.log("field-content",fieldContent);
    return fieldContent;
  };

  const doSearch = useCallback(
    (evt) => {
      if (evt && evt?.preventDefault) {
        evt.preventDefault();
      }
      handleSubmit(values);
    },
    [values, handleSubmit]
  );
  /*
      useEffect(() => {
        var a = true;
        if(a) { return; }
        return hookReturn(doSearch);
      }, [doSearch]);
    */
  useEffect(() => {
    return hookReturn(doSearch);
    // technically should change if doSearch changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //    <Dialog className="search-dialog" isOpen={isOpen} title={title} style={{ width: '1024px' }} onClose={onClose}>
  return (
    <>
      <ModalWindow
        isOpen={isOpen}
        onClose={onClose}
        header="Search"
        maxWidth="lg"
        actions={
          <>
            <Tooltip title="Save as the default search fields.">
              <IconButton onClick={handleClickOpen}>
                <Save />
              </IconButton>
            </Tooltip>
            <Tooltip title="Reset form to the default search fields.">
              {/* <IconButton onClick={doLoadFields}> */}
              <IconButton onClick={doResetFields}>
                <Refresh />
              </IconButton>
            </Tooltip>
            {searchNameFormProp !== null && searchNameFormProp?.length > 0 && (
              <SplitButton
                buttonStyle={customCheckbox}
                options={searchNameFormProp}
                setSelectedId={setSelectedId}
                loadFields={loadFields}
                propName={propName}
                setOpenSnackbar={setOpenSnackbar} 
                setToastMessage={setToastMessage} 
                setResponseOption={setResponseOption}
              />
            )}
            <Button
              style={{ marginLeft: "auto" }}
              variant="contained"
              onClick={doSearch}
              startIcon={<Search />}
            >
              Search
            </Button>
            <Snackbar open={openSnackbar} autoHideDuration={3000}>
              <MuiAlert elevation={6} variant="filled" severity="success">
                {toastMessage}
              </MuiAlert>
            </Snackbar>
          </>
        }
      >
        <div className="search-dialog__body">
          <div className="search-dialog__fields">
            <form autoComplete="off" onSubmit={doSearch}>
              <div className="grid12">{isOpen ? renderFields() : []}</div>
            </form>
          </div>
          <div className="search-dialog__fields-add">
            <Button onClick={addRow} startIcon={<AddBox />}>
              Add another search field
            </Button>
          </div>
        </div>
      </ModalWindow>
      <Dialog open={open}>
        <DialogTitle>Save Search</DialogTitle>
        <DialogContent>
          <TextField
            required
            autoFocus
            margin="dense"
            name=".searchName"
            label="Search Name"
            value={searchName}
            type="text"
            fullWidth
            variant="standard"
            onChange={onChangeField}
            error={error} // Set error state for TextField if not search name
            helperText={error ? 'Search Name is required' : 'Use "default" if this is your prefered search'}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={doSaveFields}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export const SearchForm = (props) => {
    console.log('[SF]', 'render with', props);
    const userContext = useUserContext();
    const [formData, setFormData] = useState<SearchFieldValue[]|null>(null);
    const [searchNameForm, setSearchNameForm] = useState<any[]|null>(null);
    const [selectedId, setSelectedId] = useState<string|null>(null);
    const [values, setValues] = useState<SearchFieldValue[]>([]);
    const [searchName, setSearchName] = useState<string|undefined>();
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [responseOption, setResponseOption] = useState('');
    const fieldTypesByName = {};
    props.fieldTypes.forEach((field) => {
        if (field.type === 'group') {
            field.fields.forEach((field) => {
                fieldTypesByName[field.id] = field;
            });
        } else {
            fieldTypesByName[field.id] = field;
        }
    });
    const convertFieldsFromParams = (params) => {
        const formData:SearchFieldValue[] = [];
        params.forEach((field) => {
            field.id = field.type;
            const fieldType = fieldTypesByName[field.name];
            console.log('[SF] V0',field.name);
            if (!fieldType) return;
            console.log('[SF] V01',field.name);
            fieldType.variants.forEach((variant) => {
                if (variant.id === field.type) {
                    if (variant.setValue) {
                        formData.push({column: fieldType, variant: variant, value: variant.setValue(field.value)});
                    } else {
                        const p = field.value ? field.value.split(',') : [];
                        if (variant.multi) {
                            console.log('[SF] V1');
                            formData.push({column: fieldType, variant: variant, value: p});
                        } else {
                            console.log('[SF] V2');
                            if(p &&p.length) {
                                p.forEach(function (v) {
                                    formData.push({column: fieldType, variant: variant, value: v.replace('%%', ',')});
                                })
                            } else {
                                formData.push({column: fieldType, variant: variant, value: null});
                            }
                        }
                    }
                }
            })
        });
        console.log('[SF] convert',params,formData,fieldTypesByName);
        return formData;
    }

    const convertFieldsToParams = (fieldsInput, withData) => {
        const fieldObject = {};
        console.log('convertFieldsToParams', fieldsInput, withData);
        fieldsInput.forEach((field) => {
            let value:string|null = null;
            if (withData) {
                if (!field.variant.multi) {
                    value = field.variant.getValue ? field.variant.getValue(field.value) : field.value;
                } else {
                    value = field.value;
                }
                if (value === undefined || value === '') return;

                // handle the case where a field variant is used multiple times
                // and where a field variant contains multiple values
                if (!field.variant.setValue) {
                    if (Array.isArray(value)) {
                        value = (value as Array<any>)?.map((v) => v?.id ? v.id : v).filter((v) => v).join(',');
                    } else {
                        if(typeof value === 'string') {
                            value = (value as string)?.replace(',', '%%');
                        }
                    }
                }
            }
            if (fieldObject[field.column.id + '-' + field.variant.id] && withData) {
                fieldObject[field.column.id + '-' + field.variant.id].value += ',' + value;
            } else {
                const toPush: SearchFieldParam = {name: field.column.id, type: field.variant.id, value: value??undefined};
                fieldObject[field.column.id + '-' + field.variant.id] = toPush;
            }
        });
        const fields:any[] = [];
        Object.entries(fieldObject).forEach(function ([, v]) {
            fields.push(v);
        })
        console.log('convertFieldsToParams', fieldObject, fields);
        return fields;
    }

    const doSearch = useCallback((formData) => {
        const fields = convertFieldsToParams(formData, true);
        props.onSearch(fields);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const saveFields = async (values, searchName) => {
      console.log('save', convertFieldsToParams(values, true), searchName);
      const response = await userContext?.setOption(
        props.name + '-search',
        convertFieldsToParams(values, true),
        searchName,
        setToastMessage,
        setOpenSnackbar
      );
      console.log("Response from setOption:", response);
      setResponseOption(response??'');
    };
    
    const loadFields = useCallback((doReturn = false, clickedId='') => {
      // Check if userContext or getOption is not available
      if (userContext.hasOption(props.name + '-search')) {
        // try to load the fields from the saved search
        const {value,searchName,searchNameArray} = userContext.getOption(props.name + '-search', clickedId,true);  
        console.log('[SF]', 'setting options', value,searchNameArray,searchName,doReturn);
        if(value) {
          const newFormData = convertFieldsFromParams(value);
          console.log('[SF]', 'publishing form data', newFormData);
          setFormData(newFormData);
          setValues(newFormData);
          if (doReturn) return newFormData;
        }
        setSearchNameForm(searchNameArray);
        setSearchName(searchName);
        return true;
      } else {
        console.log('[SF]','setblank?');
        //setValues(convertFieldsFromParams([]));
        setSearchNameForm([]);
        setSearchName('');
      }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData,userContext]);

    useEffect(() => {
        loadFields(false, ''); 
        console.log("[SF]","response", responseOption)
    }, [responseOption]);
    
    // find formdata from somewhere...
    useEffect(() => {
        console.log('[SF]', 'finding fields');
        let newFormData = formData;
        // see if there are url search parameters, if so use that...
        if (props.params && props.params.length) {
            console.log('[SF]', 'finding search params in URL');
            newFormData = convertFieldsFromParams(props.params);
            if (newFormData && newFormData.length) {
                console.log('[SF] URL parsed into', newFormData);
                setFormData(newFormData);
                setValues(newFormData);
                return;
            }
        }
        // otherwise try loading fields from the saved searches
        if (!formData || !newFormData) {
            // try loading...
            console.log('[SF]', 'loading fields from session');
            if (loadFields()) {
                return;
            }
//            setFormData([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    console.log('[SF]', 'rendering [SFR] with', formData, values, props.isOpen,props.name,selectedId);
    return (<SearchFormRenderer label={props.label} initialValues={formData??[]} fieldTypes={props.fieldTypes}
                                handleSubmit={doSearch}
                                loadFields={loadFields} saveFields={saveFields} isOpen={props.isOpen}
                                onClose={props.onCancel} searchNameFormProp={searchNameForm} setSelectedId={setSelectedId} values={values} 
                                setValues={setValues} setSearchName={setSearchName} searchName={searchName}
                                openSnackbar={openSnackbar} toastMessage={toastMessage} 
                                setOpenSnackbar={setOpenSnackbar} setToastMessage={setToastMessage}
                                propName = {props.name} setResponseOption={setResponseOption} />);
};

SearchForm.propTypes = {
    isOpen: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    params: PropTypes.array,
    onSearch: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    fieldTypes: PropTypes.array.isRequired
};
/*
export default compose(
  withUserContext)
(SearchForm2);*/

export default SearchForm;